// src/components/InstallPrompt.tsx
import { useEffect, useState } from "react";
import type { BeforeInstallPromptEvent } from '../types/global';

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent | null>(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const handler = (e: Event) => {
      const evt = e as BeforeInstallPromptEvent;
      evt.preventDefault();
      setDeferredPrompt(evt);
      setShowPrompt(true);
    };

    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    console.log("User response to the install prompt:", outcome);

    setDeferredPrompt(null);
    setShowPrompt(false);
  };

  if (!showPrompt) return null;

  return (
    <div style={{
      position: "fixed",
      bottom: 20,
      left: 20,
      right: 20,
      backgroundColor: "#fff",
      border: "1px solid #ccc",
      padding: "16px",
      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
      zIndex: 9999,
      maxWidth: 500,
      margin: "auto"
    }}>
      <img
        src="/screenshots/preview.png"
        alt="App preview"
        style={{ width: "100%", borderRadius: "8px" }}
      />
      <p style={{ marginTop: "8px" }}>Install this app for a better experience.</p>
      <button onClick={handleInstall}>Install App</button>
    </div>
  );
}